import { Modal } from "react-bootstrap";

interface LayoutModalModel {
  title: string;
  show: boolean;
  onHide: () => void;
  children: React.ReactNode;
  actions?: React.ReactNode | React.ReactNode[];
}

export const LayoutModal = ({
  title,
  show,
  onHide,
  children,
  actions,
}: LayoutModalModel) => {
  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {actions && <Modal.Footer>{actions}</Modal.Footer>}
    </Modal>
  );
};
